import { type CreditPackageResponse } from 'TYPES/index'

export interface BestValueDiscount {
  packageId: string
  percent: number
}

export const getBestValueDiscount = (
  packages: CreditPackageResponse[],
): BestValueDiscount | undefined => {
  const rated = packages.flatMap(({ id, credits, price }) =>
    id !== undefined && credits !== undefined && price !== undefined && price > 0
      ? [{ id, ratio: credits / price }]
      : [],
  )

  const sorted = [...rated].sort((a, b) => b.ratio - a.ratio)
  const best = sorted.at(0)
  const runnerUp = sorted.at(1)
  const base = sorted.at(-1)

  if (best === undefined || runnerUp === undefined || base === undefined) return undefined
  if (best.ratio === runnerUp.ratio) return undefined

  const percent = Math.round((1 - base.ratio / best.ratio) * 100)

  return percent > 0 ? { packageId: best.id, percent } : undefined
}
